import styles from "./BottomBarItemBlank.module.scss"

export default function BottomBarItemBlank() {
    return <div className={styles.base}></div>
}
